<a routerLink="/tickers/stock/{{ticker.symbol}}">
  <div class="ticker-tile">
    <span class="sub-tile symbol">{{ ticker.symbol }}</span>
    <span class="sub-tile name">{{ ticker.name }}</span>
    <span class="sub-tile type">{{ ticker.type }}</span>
    <span class="sub-tile region">{{ ticker.region }}</span>
    <span class="sub-tile currency">{{ ticker.currency }}</span>
  </div>
</a>
